import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

// Added as part of df9r3t7e-desktop-more-deals-dropdown
export const AllOffersDropdownLoader = () => {
  return (
    <>
      {Array(3)
        .fill('')
        .map((_, index) => (
          <Box
            key={`dropdown-loader-${index}`}
            paddingTop="s400"
            paddingBottom="s400"
            paddingRight="s500"
            paddingLeft="s500"
          >
            <Box
              display="flex"
              alignItems="flex-end"
              justifyContent="space-between"
            >
              <SkeletonLoader width={60} height={22} />
              <SkeletonLoader width={29} height={20} />
            </Box>
          </Box>
        ))}
    </>
  )
}
